import { z } from "zod";

export const TagSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
  sortOrder: z.number(),
  isArchived: z.boolean(),
});

export type Tag = z.infer<typeof TagSchema>;
